import { t } from '@/plugins/i18n'
export const editableTabs = [
  {
    title: t('全部'),
    name: 'all'
  },
  {
    title: t('未关联'),
    name: '0'
  },
  {
    title: t('已关联'),
    name: '1'
  }
  // {
  //   title: t('关联异常'),
  //   name: '2'
  // }
]

export const shopProductBindStatusSnum: any = {
  0: t('未关联'),
  1: t('已关联'),
  2: t('关联异常')
}

export const associatedColumns:any = [
  {
    label: t('客户商品sku'),
    prop: 'itemRemark',
    align: 'center',
    width: 200,
    slotName: 'itemRemark'
  },
  {
    label: t('店铺商品信息'),
    prop: 'thirdItemName',
    align: 'center',
    width: 200,
    slotName: 'shopProductInfo'
  },
  {
    label: t('tiktok商品状态'),
    prop: 'thirdItemStatus',
    width: 200,
    slotName: 'thirdItemStatus'
  },
  {
    label: t('售卖价格'),
    prop: 'thirdSalePrice',
    align: 'center',
    slotName: 'thirdSalePrice'
  },
  {
    label: t('中国商品附加项'),
    prop: 'additionList',
    align: 'center',
    slotName: 'additionList',
    width: 200
  },
  {
    label: t('韩国商品附加项'),
    prop: 'additionList2',
    align: 'center',
    slotName: 'additionList2',
    width: 200,
    isMultiStore: true
  },
  {
    label: t('已关联SKU数量'),
    prop: 'bindingCount',
    align: 'center'
  },
  {
    label: t('未关联sku数量'),
    prop: 'unbindingCount',
    align: 'center'
  }
]

export const associatedChildColumns: any = [
  {
    label: t('sku'),
    prop: 'thirdSkuCode',
    align: 'center',
    slotName: 'thirdSkuCode'
  },
  {
    label: t('客户商品sku'),
    prop: 'itemRemark',
    align: 'center'
  },
  {
    label: t('规格'),
    prop: 'thirdItemAttribute',
    align: 'center',
    slotName: 'thirdItemAttribute'
  },
  {
    label: t('售卖价格'),
    prop: 'thirdSalePrice',
    align: 'center',
    slotName: 'thirdSalePrice'
  },
  {
    label: t('关联状态'),
    prop: 'bindStatus',
    align: 'center',
    slotName: 'bindStatus'
  },
  {
    label: t('供货商品数'),
    prop: 'mappingCount',
    width: 130,
    align: 'center'
  },
  {
    label: t('关联商品信息'),
    prop: 'productInfo',
    align: 'center',
    width: 200,
    slotName: 'productInfo'
  },
  {
    label: t('商品采购国家'),
    prop: 'productCountry',
    align: 'center',
    slotName: 'productCountry',
    isMultiStore: true
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('商品附加项'),
    prop: 'additionList',
    align: 'center',
    slotName: 'additionList'
  },
  {
    label: t('价格'),
    prop: 'productSellPrice',
    align: 'center',
    slotName: 'productSellPrice'
  }
]
export const tableConfig = {
  showHandler: true,
  showSelection: true,
  showExpand: true,
  setHeight: true,
  rowKey: 'shopItemId',
  path: 'AssociatedProductlib'
}

export const childConfig = {
  showHandler: true,
  rowKey: 'shopItemId'
}

export const childApiConfig = {
  listPath: 'data'
}
